import React, { useContext, useState } from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import LoginRequiredModal from '../../common/login_required_modal/login_required_modal.component';
import AppContext from '../../context';
import FeatureIcons from '../feature_icons';
import './side_bar.component.css';

const SideBar = () => {
  const context = useContext(AppContext);
  const [isLoginModalVisible, setIsLoginModalVisible] = useState(false);

  const tooltip = (props) => {
    return (
      <Tooltip id="tools-nav" {...props}>
        {props.text}
      </Tooltip>
    );
  };

  const handleToolClick = () => {
    if (!context.user.is_authenticated) {
      setIsLoginModalVisible(true);
      return;
    }
  };

  return (
    <>
      <div className="side_panel_wrapper">
        <div className="side_panel_item">
          <div className="tracking_tools">
            <OverlayTrigger
              placement="left"
              overlay={(props) =>
                tooltip({ ...props, text: 'Ideas Dashboard' })
              }
            >
              <a href="/in/ideas-dashboard" className="side_menu_link">
                <span>
                  <FeatureIcons feature="ideas-dashboard" />
                </span>
                <span className="panel_item_name">Ideas Dashboard</span>
              </a>
            </OverlayTrigger>
          </div>
          <div>
            <OverlayTrigger
              placement="left"
              overlay={(props) => tooltip({ ...props, text: 'Timeline' })}
            >
              <a
                href={
                  context.user.is_authenticated ? '/in/timeline' : undefined
                }
                onClick={() => handleToolClick()}
                className="side_menu_link"
              >
                <span>
                  <FeatureIcons feature="timeline" />
                </span>
                <span className="panel_item_name">Timeline</span>
              </a>
            </OverlayTrigger>
          </div>
          <div>
            <OverlayTrigger
              placement="left"
              overlay={(props) => tooltip({ ...props, text: 'Watchlist' })}
            >
              <a
                href={
                  context.user.is_authenticated ? '/in/watchlist' : undefined
                }
                onClick={() => handleToolClick()}
                className="side_menu_link"
              >
                <span>
                  <FeatureIcons feature="watchlist" />
                </span>
                <span className="panel_item_name">Watchlist</span>
              </a>
            </OverlayTrigger>
          </div>
          <div>
            <OverlayTrigger
              placement="left"
              overlay={(props) => tooltip({ ...props, text: 'Portfolio' })}
            >
              <a
                href={
                  context.user.is_authenticated
                    ? '/in/portfolio'
                    : '/in/portfolio/sample'
                }
                className="side_menu_link active"
              >
                <span>
                  <FeatureIcons feature="portfolio" highlight={true} />
                </span>
                <span className="panel_item_name">Portfolio</span>
              </a>
            </OverlayTrigger>
          </div>
          <div>
            <OverlayTrigger
              placement="left"
              overlay={(props) => tooltip({ ...props, text: 'Alerts' })}
            >
              <a
                href={context.user.is_authenticated ? '/in/alerts' : undefined}
                onClick={() => handleToolClick()}
                className="side_menu_link"
              >
                <span>
                  <FeatureIcons feature="alerts" />
                </span>
                <span className="panel_item_name">Alerts</span>
              </a>
            </OverlayTrigger>
          </div>
          <div className="separator"></div>
          <div>
            <OverlayTrigger
              placement="left"
              overlay={(props) =>
                tooltip({ ...props, text: 'Company & Sector Research' })
              }
            >
              <a href="/?r=n" className="side_menu_link">
                <span>
                  <FeatureIcons feature="company-sector-research" />
                </span>
                <span className="panel_item_name">Research</span>
              </a>
            </OverlayTrigger>
          </div>
          <div>
            <OverlayTrigger
              placement="left"
              overlay={(props) => tooltip({ ...props, text: 'Filter' })}
            >
              <a href="/filter/popular-queries" className="side_menu_link">
                <span>
                  <FeatureIcons feature="stock-screener" />
                </span>
                <span className="panel_item_name">Stock Screener</span>
              </a>
            </OverlayTrigger>
          </div>
          <div>
            <OverlayTrigger
              placement="left"
              overlay={(props) => tooltip({ ...props, text: 'Market Monitor' })}
            >
              <a href="/in/markets" className="side_menu_link">
                <span>
                  <FeatureIcons feature="markets" />
                </span>
                <span className="panel_item_name">Market</span>
              </a>
            </OverlayTrigger>
          </div>
          <div>
            <OverlayTrigger
              placement="left"
              overlay={(props) => tooltip({ ...props, text: 'Raw Materials' })}
            >
              <a href="/in/raw-materials" className="side_menu_link">
                <span>
                  <FeatureIcons feature="raw-materials" />
                </span>
                <span className="panel_item_name">Raw Material</span>
              </a>
            </OverlayTrigger>
          </div>
          {/* <div>
            <OverlayTrigger
              placement="left"
              overlay={(props) =>
                tooltip({ ...props, text: 'Macro Indicators' })
              }
            >
              <a href="/in/macro" className="side_menu_link">
                <img
                  src={MacroIndicatorsIcon}
                  alt="macro"
                  className="side_menu_icon"
                />
                 <h5>Macro</h5>
              </a>
            </OverlayTrigger>
          </div> */}
        </div>
      </div>
      <LoginRequiredModal
        isVisible={isLoginModalVisible}
        setIsVisible={setIsLoginModalVisible}
      />
    </>
  );
};

export default SideBar;
